
/**
 * 递归取值，返回树节点
 * @param list
 */
export function getTreeData (list, key = 'id', name = 'name') {
  const recursiveData = list => {
    return list.map(t => {
      const tree = {
        id: t[key],
        label: t[name],
        leaf: false,
        hasChildren: t.has_children
      }

      if (t.children && t.children.length) {
        tree.children = recursiveData(t.children)
      }

      return tree
    })
  }

  return recursiveData(list)
}
